import React from "react";
import Swal from "sweetalert2";

const Loading = ({ loading }) => {
  const showLoader = (isLoading) => {
    if (isLoading) {
      Swal.fire({
        title: "Processing...",
        html: "Please wait a moment.",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    } else {
      Swal.close(); // Close the loader if loading is false
    }
  };

  React.useEffect(() => {
    showLoader(loading);
  }, [loading]);

  return null;
};

export default Loading;
